import LocalizationService from '../utils/LocalizationService'

const languageCode = LocalizationService.getCurrentLanguage()

export const getReportSchema = (agency, summary) => agency.report_schemas.find(schema => schema._id === summary.report_schema_id)

export const getAgencyStatusMap = (agency, name) => agency.display_pages
  ? agency.display_pages.display_statuses.find(status => status.title[languageCode] === name)
  : []
